/**
 * Transform the response of the product service to a product detail
 *
 */

import { PRODUCT_DETAIL_VARIATION_TYPES } from 'core/domains/utilities';
import type { ProductDetail, ProductDetailResponse } from '../../@types';
import { ProfitabilityProductType } from '../../@types';

export function productDetail({ data }: ProductDetailResponse): ProductDetail['data']['item'] {
  if (data.items.length) {
    const group = data.items[0].group;
    return {
      skuOrganization: data.items[0].skuOrganization,
      sku: data.items[0].sku,
      name: data.items[0].name,
      imageObjects: data.items[0].imageObjects,
      priceWrapper: data.items[0].priceWrapper,
      group,
      details: data.items[0].details,
      tags: data.items[0].badge,
      isAvailable: data.items[0].inventory?.managed?.available || false,
      isCustomCombo: data.items[0].productType === 'CUSTOM_KIT',
      departments: data.items[0].departments || [],
      kits: data.items[0].kit.kits || [],
      resellerOnly:
        data.items[0].cycles[0].profitabilityProductType === ProfitabilityProductType.RESELLER,
      variation: group.items[0]?.properties?.length
        ? PRODUCT_DETAIL_VARIATION_TYPES.COLOR
        : PRODUCT_DETAIL_VARIATION_TYPES.VOLUME,
      hasSimilar: data.items[0].hasSimilar,
    };
  }

  return {} as unknown as ProductDetail['data']['item'];
}
